// import React, { useState, useEffect } from 'react';
// import { useNavigate } from 'react-router-dom';
// import '../CSS/pdashboard.css';
// import { ArrowLeft, MapPin, Clock, Bell, RefreshCw } from "lucide-react";
// import logo from '../assets/logo.png';

// function Dashboard() {
//   const navigate = useNavigate();
//   const [patientData, setPatientData] = useState(null);
//   const [tokensAhead, setTokensAhead] = useState(0);
//   const [estimatedMinutes, setEstimatedMinutes] = useState(0);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');

//   const fetchPatientStatus = async () => {
//     const cid = localStorage.getItem('patientCID');

//     if (!cid) {
//       setError('No CID found. Please login again.');
//       setLoading(false);
//       return;
//     }

//     try {
//       const response = await fetch(`https://q-less.onrender.com/api/patient/status/${cid}`);
//       const data = await response.json();

//       if (response.ok) {
//         setPatientData(data.patient);
//         setTokensAhead(data.tokensAhead);
//         setEstimatedMinutes(data.estimatedMinutes);
//         setError('');
//       } else {
//         setError(data.message || 'Patient not found');
//         setTimeout(() => {
//           localStorage.removeItem('patientCID');
//           navigate('/login');
//         }, 2000);
//       }
//     } catch (err) {
//       setError('Failed to fetch status. Please try again.');
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchPatientStatus();
//     const interval = setInterval(fetchPatientStatus, 5000);
//     return () => clearInterval(interval);
//   }, []);

//   const handleRefresh = () => {
//     setLoading(true);
//     fetchPatientStatus();
//   };

//   const handleBack = () => {
//     navigate('/login');
//   };

//   if (loading && !patientData) {
//     return (
//       <div className="status-container">
//         <div className="loading-center">
//           <RefreshCw size={24} className="icon-btn spin" />
//           <p>Loading your status...</p>
//         </div>
//       </div>
//     );
//   }

//   if (error && !patientData) {
//     return (
//       <div className="status-container">
//         <header className="status-header">
//           <div className="header-left">
//             <ArrowLeft className="back-icon" size={20} onClick={handleBack} />
//             <img src={logo} alt="Q-Less Logo" className="logo-img" />
//           </div>
//         </header>
//         <main className="error-main">
//           <p className="error-text">{error}</p>
//           <button className="retry-btn" onClick={handleBack}>
//             Go Back to Login
//           </button>
//         </main>
//       </div>
//     );
//   }

//   return (
//     <div className="status-container">
//       <header className="status-header">
//         <div className="header-left">
//           <ArrowLeft size={20} className="back-icon" onClick={handleBack} />
//           <img src={logo} alt="Q-Less Logo" className="logo-img" />
//         </div>

//         <div className="header-right">
//           <RefreshCw size={18} className="icon-btn" onClick={handleRefresh} />
//           <Bell size={18} className="icon-btn" />
//         </div>
//       </header>

//       <div className="token-card">
//         <div className="token-header">
//           <p>Your Token</p>
//           <h2>{patientData?.tokenNumber}</h2>
//           <span>{tokensAhead} {tokensAhead === 1 ? 'Patient' : 'Patients'} Ahead</span>
//         </div>

//         <div className="token-info">
//           <div className="info-box">
//             <MapPin className="info-icon" size={18} />
//             <div>
//               <p className="info-title">Location</p>
//               <p className="info-value">{patientData?.chamberAssignment}</p>
//             </div>
//           </div>

//           <div className="info-box">
//             <Clock className="info-icon" size={18} />
//             <div>
//               <p className="info-title">Expected Time</p>
//               <p className="info-value">
//                 {tokensAhead > 0 ? `${estimatedMinutes} mins` : 'Your turn is next!'}
//               </p>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* ===== Updated 4-row, 1-column Information Section ===== */}
//       <div className="info-card">
//         <h3>Your Information</h3>

//         <div className="info-grid">

//           <div className="info-box-row">
//             <p className="label">Name</p>
//             <p className="value">{patientData?.name}</p>
//           </div>

//           <div className="info-box-row">
//             <p className="label">CID</p>
//             <p className="value">{patientData?.cid}</p>
//           </div>

//           <div className="info-box-row">
//             <p className="label">Age</p>
//             <p className="value">{patientData?.age}</p>
//           </div>

//           <div className="info-box-row">
//             <p className="label">Chief Complaint</p>
//             <p className="value">{patientData?.complaint}</p>
//           </div>

//         </div>
//       </div>

//       <footer className="status-footer">© 2025 Q-less. All Rights Reserved.</footer>
//     </div>
//   );
// }

// export default Dashboard;

import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import '../CSS/pdashboard.css';
import { ArrowLeft, MapPin, Clock, Bell, RefreshCw } from "lucide-react";
import logo from '../assets/logo.png';

function Dashboard() {
  const navigate = useNavigate();
  const [patientData, setPatientData] = useState(null);
  const [tokensAhead, setTokensAhead] = useState(0);
  const [estimatedMinutes, setEstimatedMinutes] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // ✅ FIXED: Wrapped in useCallback so it can be safely used in useEffect
  const fetchPatientStatus = useCallback(async () => {
    const cid = localStorage.getItem('patientCID');

    if (!cid) {
      setError('No CID found. Please login again.');
      setLoading(false);
      return;
    }

    try {
      const response = await fetch(`https://q-less.onrender.com/api/patient/status/${cid}`);
      const data = await response.json();

      if (response.ok) {
        setPatientData(data.patient);
        setTokensAhead(data.tokensAhead);
        setEstimatedMinutes(data.estimatedMinutes);
        setError('');
      } else {
        setError(data.message || 'Patient not found');
        setTimeout(() => {
          localStorage.removeItem('patientCID');
          navigate('/login');
        }, 2000);
      }
    } catch (err) {
      setError('Failed to fetch status. Please try again.');
    } finally {
      setLoading(false);
    }
  }, [navigate]); // ⚠️ navigate is used inside the function, so it must be included

  // ✅ FIXED: dependency array includes fetchPatientStatus
  useEffect(() => {
    fetchPatientStatus();
    const interval = setInterval(fetchPatientStatus, 5000);
    return () => clearInterval(interval);
  }, [fetchPatientStatus]);

  const handleRefresh = () => {
    setLoading(true);
    fetchPatientStatus();
  };

  const handleBack = () => {
    navigate('/login');
  };

  if (loading && !patientData) {
    return (
      <div className="status-container">
        <div className="loading-center">
          <RefreshCw size={24} className="icon-btn spin" />
          <p>Loading your status...</p>
        </div>
      </div>
    );
  }

  if (error && !patientData) {
    return (
      <div className="status-container">
        <header className="status-header">
          <div className="header-left">
            <ArrowLeft className="back-icon" size={20} onClick={handleBack} />
            <img src={logo} alt="Q-Less Logo" className="logo-img" />
          </div>
        </header>
        <main className="error-main">
          <p className="error-text">{error}</p>
          <button className="retry-btn" onClick={handleBack}>
            Go Back to Login
          </button>
        </main>
      </div>
    );
  }

  return (
    <div className="status-container">
      <header className="status-header">
        <div className="header-left">
          <ArrowLeft size={20} className="back-icon" onClick={handleBack} />
          <img src={logo} alt="Q-Less Logo" className="logo-img" />
        </div>

        <div className="header-right">
          <RefreshCw size={18} className="icon-btn" onClick={handleRefresh} />
          <Bell size={18} className="icon-btn" />
        </div>
      </header>

      <div className="token-card">
        <div className="token-header">
          <p>Your Token</p>
          <h2>{patientData?.tokenNumber}</h2>
          <span>{tokensAhead} {tokensAhead === 1 ? 'Patient' : 'Patients'} Ahead</span>
        </div>

        <div className="token-info">
          <div className="info-box">
            <MapPin className="info-icon" size={18} />
            <div>
              <p className="info-title">Location</p>
              <p className="info-value">{patientData?.chamberAssignment}</p>
            </div>
          </div>

          <div className="info-box">
            <Clock className="info-icon" size={18} />
            <div>
              <p className="info-title">Expected Time</p>
              <p className="info-value">
                {tokensAhead > 0 ? `${estimatedMinutes} mins` : 'Your turn is next!'}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ===== Updated 4-row, 1-column Information Section ===== */}
      <div className="info-card">
        <h3>Your Information</h3>

        <div className="info-grid">

          <div className="info-box-row">
            <p className="label">Name</p>
            <p className="value">{patientData?.name}</p>
          </div>

          <div className="info-box-row">
            <p className="label">CID</p>
            <p className="value">{patientData?.cid}</p>
          </div>

          <div className="info-box-row">
            <p className="label">Age</p>
            <p className="value">{patientData?.age}</p>
          </div>

          <div className="info-box-row">
            <p className="label">Chief Complaint</p>
            <p className="value">{patientData?.complaint}</p>
          </div>

        </div>
      </div>

      <footer className="status-footer">© 2025 Q-less. All Rights Reserved.</footer>
    </div>
  );
}

export default Dashboard;
